<script setup lang="ts">
import { Building2 } from 'lucide-vue-next';

import PlanFeaturesList from '@/components/settingsMenu/sections/PlanFeaturesList.vue';
import { enterprisePlanFeatures } from '@/components/settingsMenu/sections/plansFeatures';
import PlanTitle from '@/components/settingsMenu/sections/PlanTitle.vue';
import Button from '@/components/ui/button/Button.vue';
import { SubscriptionPlan } from '@/types';

const props = defineProps<{
    currentSubscriptionPlan?: SubscriptionPlan;
}>();

const handleContactSales = () => {
    window.open(
        'https://meetings.hubspot.com/cecile-etchemendy',
        '_blank',
        'noopener,noreferrer'
    );
};
</script>

<template>
    <section
        class="plan-card flex flex-col gap-6 p-5 rounded-xl border border-border bg-background"
    >
        <PlanTitle
            title="Enterprise"
            description="Ideal for large companies."
            :icon="Building2"
            :isCurrentPlan="
                props.currentSubscriptionPlan &&
                props.currentSubscriptionPlan === SubscriptionPlan.ENTERPRISE
            "
        />

        <p class="price text-3xl font-semibold">Custom</p>
        <div class="features space-y-2">
            <p class="text-sm font-medium">All Pro features</p>
            <PlanFeaturesList :features="enterprisePlanFeatures" size="sm" />
        </div>

        <Button
            variant="outline"
            class="w-full mt-auto"
            :disabled="
                props.currentSubscriptionPlan &&
                props.currentSubscriptionPlan === SubscriptionPlan.ENTERPRISE
            "
            @click="handleContactSales"
        >
            {{
                props.currentSubscriptionPlan &&
                props.currentSubscriptionPlan === SubscriptionPlan.ENTERPRISE
                    ? 'Current plan'
                    : 'Contact sales'
            }}
        </Button>
    </section>
</template>
